// Func = limiting Scope for this file

document.addEventListener("DOMContentLoaded", DOMReady);

let lastScrollTop = 0;

var opened = 0;
var start = $('#arriveInput').attr('value');
var end = $('#departureInput').attr('value');

(function(){

	//booking Cta
	if(document.getElementById('booking-cta')){
		document.getElementById('booking-cta').addEventListener('click',function(e){
			e.preventDefault();
			if(this.classList.contains('open')){
				this.classList.remove('open');
				document.getElementById('header').classList.remove('booking-open');
				document.getElementById('bookingBlock').classList.remove('open');
				this.getElementsByTagName('span')[0].innerHTML = 'Book Now';
				document.querySelector("body").classList.remove('noScroll');
			} else {
				this.classList.add('open');
				document.getElementById('header').classList.add('booking-open');
				document.getElementById('bookingBlock').classList.add('open');
				this.getElementsByTagName('span')[0].innerHTML = 'Close';
				document.querySelector("body").classList.add('noScroll');

				document.getElementById('menu-cta-js').classList.remove('open');
				document.getElementById('menu-cta-js').parentElement.classList.remove('open');
				document.getElementById('menu-text-js').innerHTML = "menu";
				document.getElementById('main-menu').classList.remove('open');
				document.getElementById('header').classList.remove('open-menu');
			}
		})
	}

	
	$(document).ready(function () {

		//To create after event 
		$.datepicker._updateDatepicker_original = $.datepicker._updateDatepicker;
		$.datepicker._updateDatepicker = function (inst) {
			$.datepicker._updateDatepicker_original(inst);
			var afterShow = this._get(inst, 'afterShow');
			if (afterShow)
				afterShow.apply((inst.input ? inst.input[0] : null));  // trigger custom callback
		}
		
		
		$('#bookingCalendar').datepicker({
			changeMonth: false,
			dateFormat: 'mm-dd-yy',
			numberOfMonths: 2,
			minDate:0,
			beforeShowDay: function (date) {

				$.datepicker._defaults.dateFormat = "mm-dd-yy";
				var startDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, start);
				var endDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, end);
				if (date.getTime() == startDate.getTime()) {
					return [true, "startday"];
				} else {
					if (date.getTime() == endDate.getTime()) {
						return [true, "endday"];
					} else {
						if (date.getTime() > startDate.getTime() && date.getTime() < endDate.getTime()) {
							return [true, "days"];
						} else {
							return [true, ""];
						}
					}
				}
			},
			onSelect: function (date) {
				var arrive = $.datepicker.parseDate($.datepicker._defaults.dateFormat, start);
				var departure = $.datepicker.parseDate($.datepicker._defaults.dateFormat, end);
				var selectedDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, date);

				if (opened == 0) {
					opened = 1;
					start = date;
					end = date;
					
				} else {
					opened = 0;
					if (selectedDate <= arrive) {
						end = start;
						start = date;
					} else {
						end = date;
					}	
				}

				$('#arriveInput').attr('value', start);
				$('#departureInput').attr('value', end);

				document.getElementById("altDates").value = start + ' / ' + end;

			}
		});	



		//Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]
		let DATE_STYLE = [true];
		function calendarRange(date){			
			let d1=$.datepicker.parseDate(DATE_FORMAT,$('#CheckIn').val());		
			let d2=$.datepicker.parseDate(DATE_FORMAT,$('#CheckOut').val());
			if (d1 && date.getTime() == d1.getTime() || d2 && date.getTime() == d2.getTime()) {
				DATE_STYLE[1] = 'highlight-top';
			}else if(date > d1 && date < d2){
				DATE_STYLE[1] = 'highlight';
			}else{
				DATE_STYLE[1] = '';
			}
			return DATE_STYLE;
		}

		//Check in and check out datepicker for booking engine
		const DATE_FORMAT = ($("#CheckIn").data("format") !== undefined && $("#CheckIn").data("format")) ? $("#CheckIn").data("format") : "yy-mm-dd";		
        $( "#CheckIn" ).datepicker({
			changeMonth: true,
            dateFormat: DATE_FORMAT,
            numberOfMonths: 1,
			minDate: 0,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function( selectedDate ) {
				let getDate = $(this).datepicker('getDate');
				let newDate = new Date(getDate.getTime());
				newDate.setDate(newDate.getDate() + 3);
				$( "#CheckOut" ).datepicker( "setDate", newDate );
				$( "#CheckOut" ).datepicker( "option", "minDate", selectedDate );
			}
		});
		$( "#CheckOut" ).datepicker({
            dateFormat: DATE_FORMAT,
            changeMonth: true,
			numberOfMonths: 1,
			beforeShowDay: (date) => calendarRange(date)
		});

		// RESTAURANT MENUS FILTER
		document.querySelectorAll('.restMenus_filter li').forEach((btn, i) => {
			btn.addEventListener('click', _ => {
				document.querySelectorAll('.restMenus_filter li').forEach(b => b.classList.remove('active'));
				btn.classList.add('active');

				document.querySelectorAll('.restMenus_item').forEach(room => {
					room.classList.remove('active');
					if ( btn.dataset.tag === 'all' || btn.dataset.tag === room.dataset.tag ) {
						room.classList.add('active');
					}
				});
			});

			if (i === 0) btn.click();
		});


		// RESTAURANT MENUS FILTER MOBILE
		document.querySelectorAll('.restMenus_filterMobile select').forEach((filter, i) => {
			filter.addEventListener('change', _ => {
				document.querySelectorAll('.restMenus_item').forEach(room => {
					room.classList.remove('active');
					if ( filter.value === room.dataset.tag ) {
						room.classList.add('active');
					}
				});
			});

			if (i === 0) {
				let eventChange = document.createEvent('HTMLEvents');
				eventChange.initEvent('change', true, false);
				filter.dispatchEvent(eventChange);
			}
		});


	});

	window.onload = function() {

		
		/* Initialize Parallax Lybrary */
		if( $(window).width() > 767 ){
			let sk = skrollr.init();
		}
		
		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};


	//Hover Menu
	let currentMenuItem = $("#privary-navigation a.active").parent().index();
	$(".slideJS:eq(" + currentMenuItem + ")", ".figureSet").addClass("active");
	$("#privary-navigation > .privary-navigation__item > a").hover(function () {
		let hoverItem = $(this).parent().index();
		$(".slideJS").removeClass('active');
		$(".slideJS:eq(" + hoverItem + ")", ".figureSet").addClass("active");
	});

	// let currentMenuItem = $("#privary-navigation a.active").parent().index();
	// $(".slide:eq(" + currentMenuItem + ")", "figureSet").addClass("active");
	// $("#privary-navigation > .privary-navigation__item > a").hover(function () {
	// 	let hoverItem = $(this).parent().index();
	// 	$(".menu-hovers .slide").removeClass('active');
	// 	$(".menu-hovers .slide").removeClass('active').filter(function (idx) {
	// 		return idx % 8 === hoverItem;
	// 	}).addClass("active");
	// });

	//NOT click into page
	document.querySelector(".no-click").addEventListener('click' , (e) =>{
		e.preventDefault();
	})



}());

// Scroll header class
function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling

	// Animated Number Counter To Value - TODO: Refactor vanilla
	let scrollTemp = document.documentElement.scrollTop;
	const $intro = document.getElementById('intro');
	let stop = false;
	
	// if(stop === false) {
	// 	if( scrollTemp > ($intro.offsetTop  - 300)){


	// 		let counterSpan = $('.count-date span')[0].innerText;
	// 		let counterSpan2 = parseInt(counterSpan,10);
			
	// 		console.log(counterSpan);
	// 		for (let i = 0; i < 1886 ; i++) {
	// 			console.log(i);
	// 			counterSpan = i;
	// 			$('.count-date span')[0].innerText  = i;

	// 		// $('.count-date span').each(function () {
	// 		// 	$(this).prop('Counter',0).animate({
	// 		// 		Counter: $(this).text()
	// 		// 	}, {
	// 		// 		duration: 3000,
	// 		// 		easing: 'swing',
	// 		// 		step: function (now) {
	// 		// 			$(this).text(Math.ceil(now));
	// 		// 		}
	// 		// 	});
	// 		// 	return;
	// 		// });
	// 		console.log(stop);
	// 	}
	// 	stop = true;
	// }
	
}

// Dom Ready Funtion
function DOMReady() {

    "use strict";

	// let dotsItemHero = document.querySelector("js-hoveredItems");
	// dotsItemHero.addEventListener('mouseenter', (event) => {
	// 	this.classList.add('s-hovered');
	// }, false);

	// TODO: Refactor in vanilla: Hovered Items Navs
	$('.js-hoveredItems .js-item').hover(function() {
		$('.js-hoveredItems').addClass('s-hovered');
	}, function() {
		$('.js-hoveredItems').removeClass('s-hovered');
	});
	if(document.querySelector('.secondary-navigation__list .secondary-navigation__item a')) {
		$('.secondary-navigation__list .secondary-navigation__item a').hover(function() {
			$('.secondary-navigation__list').addClass('s-hovered');
		}, function() {
			$('.secondary-navigation__list').removeClass('s-hovered');
		});
	}
	$('.tertiary-navigation__list .tertiary-navigation__item a').hover(function() {
		$('.tertiary-navigation__list').addClass('s-hovered');
	}, function() {
		$('.tertiary-navigation__list').removeClass('s-hovered');
	});
	$('.social-media li a').hover(function() {
		$('.social-media').addClass('s-hovered');
	}, function() {
		$('.social-media').removeClass('s-hovered');
	});



	//email signup animation 
	if(document.getElementById('email-signup_email_address')){
		document.getElementById('email-signup_first_name').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})
		document.getElementById('email-signup_last_name').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})
		document.getElementById('email-signup_email_address').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})
	}
	//Form Contact animation 
    function attachEvents(elementList, eventName, handlerFunction) {
		if(typeof elementList == "string")
				elementList = document.querySelectorAll(elementList);
		for(var i = 0; i < elementList.length; i++)
				elementList[i].addEventListener(eventName, handlerFunction);
	}
	attachEvents(".form-module-wrapper input", "click", function(event) {
			this.parentElement.classList.add('moved');
	});
	attachEvents(".form-module-wrapper textarea", "click", function(event) {
			this.parentElement.classList.add('moved');
	});
 

	//TODO: scroll down click
	// document.getElementById("scroll-down").on("click", function(){
	// 	document.querySelector('body').animate({
	// 		scrollTop: document.getElementByClassName("intro-content").offset().top - 10
	// 	}, 1000);			
	// }); 

	//Click for Menu
	document.getElementById('menu-cta-js').addEventListener('click', function(e){
		e.preventDefault();
		if(!this.classList.contains('open')){
			this.parentElement.classList.add('open');
			this.classList.add('open');
			document.getElementById('menu-text-js').innerHTML = "close";
			document.getElementById('main-menu').classList.add('open');
			document.getElementById('header').classList.add('open-menu');
			document.querySelector("body").classList.add('noScroll');
			//TODO: Refactor conditional (if)
			if(document.getElementById('booking-cta')){
				document.getElementById('booking-cta').classList.remove('open');
			}
			document.getElementById('header').classList.remove('booking-open');
			document.getElementById('bookingBlock').classList.remove('open');
			
			if(document.getElementById('booking-cta')) {
				document.getElementById('booking-cta').getElementsByTagName('span')[0].innerHTML = 'Book Now';
			}

		} else {
			this.classList.remove('open');
			this.parentElement.classList.remove('open');
			document.getElementById('menu-text-js').innerHTML = "menu";
			document.getElementById('main-menu').classList.remove('open');
			document.getElementById('header').classList.remove('open-menu');
			document.querySelector("body").classList.remove('noScroll')
		}
	});
	
	//Mobile  menu
	document.getElementById('menu-sm-cta-js').addEventListener('click', function(){
		if(!this.classList.contains('open')){
			document.getElementById('menutext-js').innerHTML = "close";
			this.parentElement.classList.add('open');
			this.classList.add('open');
			document.getElementById('main-menu').classList.add('open');
			document.getElementById('header').classList.add('open-menu');
			document.querySelector("body").classList.add('noScroll');
		} else {
			this.classList.remove('open');
			this.parentElement.classList.remove('open');
			document.getElementById('menutext-js').innerHTML = "menu";
			document.getElementById('main-menu').classList.remove('open');
			document.getElementById('header').classList.remove('open-menu');
			document.querySelector("body").classList.remove('noScroll')
		}
	});
	// AccordionItems
	let accordionItems = new Array();

	// Grab the accordion items from the page
	accordionItems = document.querySelectorAll('.restMenus_cat');
	
	// Assign onclick events to the accordion item headings
	for (let i = 0; i < accordionItems.length; i++) {
		let h2 = getFirstChildWithTagName(accordionItems[i], 'H2');
		h2.onclick = toggleItem;
	}
	
	// Hide all accordion item bodies except the first
	for (let i = 1; i < accordionItems.length; i++) {
		accordionItems[i].className = 'restMenus_cat hide';
	}
	

	function toggleItem() {
		let itemClass = this.parentNode.className;
	
		// Hide all items
		for (let i = 0; i < accordionItems.length; i++) {
			accordionItems[i].className = 'restMenus_cat hide';
			accordionItems[i].getElementsByTagName('div')[0].style.height = "0";
		}
	
		// Show this item if it was previously hidden
		if (itemClass == 'restMenus_cat hide') {
			let accordionItemContent = this;
			do accordionItemContent = accordionItemContent.nextSibling; while(accordionItemContent && accordionItemContent.nodeType !== 1);
	 
			accordionItemContent.style.height = "auto";
			let divHeight = accordionItemContent.offsetHeight;
			accordionItemContent.style.height = "";
			this.parentNode.className = 'restMenus_cat';
			let that = this;
			window.setTimeout(function () {
				accordionItemContent.style.height = divHeight + 'px';
			}, 50);
		}
	}

	
	// Helper function
	function getFirstChildWithTagName(element, tagName) {
		for (let i = 0; i < element.childNodes.length; i++) {
			if (element.childNodes[i].nodeName == tagName) return element.childNodes[i];
		}
	}


}

